module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/e3491b539f53fb0e4c1cb017dc6f17c8.png";